// extracted by mini-css-extract-plugin
module.exports = {"layout":"home_layout__ehKeC","homePOCGrid":"home_homePOCGrid__7jzGC","theme-dark":"home_theme-dark__WdyDQ","theme-light":"home_theme-light___UWHw"};